// extracted by mini-css-extract-plugin
export default {"main":"bottom_main__-T7rk"};